import Page from "../pages/Newsletter";
import { pageMeta } from "../lib/meta";
import { OG_IMAGE } from "../config/heroArt";

export const meta = () =>
  pageMeta({
    title: "Newsletter: notes on system design and shipping AI | Gazar",
    description:
      "An occasional email for engineers moving from senior to staff. Architecture decisions with the trade-offs left in, and early notice when a cohort or free live session opens.",
    path: "/newsletter",
    image: OG_IMAGE.learnings,
  });

export default function Newsletter() {
  return <Page />;
}
